import React, { useMemo } from 'react';
import { View, Text } from 'react-native';

interface PdfViewerProps {
  source: { uri?: string; base64?: string };
  width?: number | string;
  height?: number | string;
  onError?: (error: any) => void;
  onLoadComplete?: (numberOfPages: number, path: string) => void;
  [key: string]: any;
}

export const PdfViewer: React.FC<PdfViewerProps> = ({ source, width = "100%", height, mimeType = 'application/pdf' , onError }) => {
  const calculatedHeight = useMemo(() => (height ? height : mimeType === "application/pdf" ? 500 : "100%"), [height, mimeType]);
  if (source?.uri) {
    // Si c'est une URL blob ou directe
    if (source.uri.startsWith('blob:') || source.uri.startsWith('http') || source.uri.startsWith('https')) {
      return (
        <embed
          src={source.uri}
          type={mimeType}
          width={width}
          height={calculatedHeight}
        />
      );
    }
    
    // Si c'est une data URI (base64)
    if (source.uri.startsWith(`data:${mimeType};base64,`)) {
      try {
        // Extraire le base64 et créer un blob
        const base64Data = source.uri.split(',')[1];
        const binaryString = atob(base64Data);
        const bytes = new Uint8Array(binaryString.length);
        
        for (let i = 0; i < binaryString.length; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        
        const blob = new Blob([bytes], { type: mimeType });
        const blobUrl = URL.createObjectURL(blob);
        
        return (
          <embed
            src={blobUrl}
            type={mimeType}
            width={width}
            height={calculatedHeight}
          />
        );
      } catch (error) {
        console.error('Erreur lors de la création du blob PDF:', error);
        if (onError) onError(error);
        return (
          <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
            <Text>Erreur lors du chargement du PDF</Text>
          </View>
        );
      }
    }
  }
  
  return (
    <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
      <Text>Aucun PDF à afficher</Text>
    </View>
  );
};